<template>
	<div class="featured_posts_listing">
		<div class="container">
			<header class="header-desktop">
				<h3
					v-if="title"
					v-html="title"
				></h3>
				<tertiary-button
					:link="parsedCta ? parsedCta : parsedCta.link"
					:label="
            parsedCta.title
              ? parsedCta.title
              : parsedCta.link
              ? parsedCta.link.title
              : '_self'
          "
				></tertiary-button>
			</header>

			<template v-if="no_slider === 'true'">
				<post-tile
					v-for="(tile, index) in parsedPageLinks"
					:key="index"
					:name="tile.title"
					:short_description="tile.description"
					:image="tile.image ? tile.image.url : null"
					:permalink="{
				url: tile.url,
				target: '_self',
				title: tile.title,
			}"
					:tag="tile.category"
					:post_type="tile.post_type"
					class='featured_post'
				></post-tile>
			</template>
			<template v-else>
				<div class="slider-slider">
					<div
						class="swiper"
						:class="section_id"
					>
						<div class="swiper-wrapper">
							<template v-if="type === 'post'">
								<post-tile
									class="swiper-slide featured_post"
									v-for="(tile, index) in parsedPageLinks"
									:key="index + '_standard'"
									:name="tile.title"
									:short_description="tile.description"
									:image="tile.image ? tile.image.url : null"
									:permalink="{
						url: tile.url,
						target: '_self',
						title: tile.title,
					}"
									:tag="tile.category"
									:post_type="tile.type"
								></post-tile>
							</template>

						</div>
						<div
							class="swiper-pagination"
							:class="'swiper-pag-' + section_id"
							v-if="Object.keys(parsedPageLinks).length > 4"
						></div>

						<div
							class="swiper-next-prev"
							v-if="Object.keys(parsedPageLinks).length > 4"
						>
							<carousel-arrow
								class="swiper-button-prev swiper-button-prv"
								:class="'swiper-button-prev-' + section_id"
								direction="prev"
								theme="dark"
							></carousel-arrow>
							<carousel-arrow
								class="swiper-button-next swiper-button-nxt"
								:class="'swiper-button-next-' + section_id"
								direction="next"
								theme="dark"
							></carousel-arrow>
						</div>
					</div>
				</div>
			</template>

		</div>
	</div>
</template>

<script>
import PostTile from './PostTile.vue';
// import SecondaryButton from './SecondaryButton.vue';
import CarouselArrow from './CarouselArrow.vue';
import Swiper from 'swiper';
import TertiaryButton from './TertiaryButton.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			swiper: null,
		};
	},

	props: {
		title: {
			default: 'Basic Page Links (with description)',
		},
		cta: {},
		basic_page_links_description: {},
		type: {},
		section_id: {},
		no_slider: {
			default: 'false',
		},
	},

	computed: {
		parsedPageLinks() {
			if (this.basic_page_links_description) {
				return JSON.parse(this.basic_page_links_description);
			} else {
				return null;
			}
		},

		parsedCta() {
			if (this.cta) {
				return JSON.parse(this.cta);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			this.initSliders();
		},

		initSliders() {
			// eslint-disable-next-line no-unused-vars
			var swiper = new Swiper('.' + this.section_id, {
				slidesPerView: 4,
				spaceBetween: 24,
				loop: false,
				grabCursor: false,
				// watchSlidesVisibility: true,
				// watchSlidesProgress: true,
				// observer: true,
				// observeParents: true,
				breakpoints: {
					400: {
						slidesPerView: 1.1,
						spaceBetween: 24,
						centeredSlides: false,
					},
					1024: {
						slidesPerView: 1.1,
						spaceBetween: 24,
					},
					1240: {
						slidesPerView: 3.5,
						spaceBetween: 24,
					},
					1490: {
						slidesPerView: 3.5,
						spaceBetween: 24,
					},
					1920: {
						slidesPerView: 3.5,
						spaceBetween: 24,
					},
				},
				hashNavigation: {
					watchState: true,
				},
				pagination: {
					el: '.swiper-pag-' + this.section_id,
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next-' + this.section_id,
					prevEl: '.swiper-button-prev-' + this.section_id,
				},
				on: {
					init: function () {
						for (let i = 0; i < this.slides.length; i++) {
							// Set opacity to 1 for the activeIndex and the next two slides
							if (i >= this.activeIndex && i <= this.activeIndex + 3) {
								this.slides[i].style.opacity = 1;
								this.slides[i].style.pointerEvents = 'all';
							} else {
								// Set opacity to 0.3 for all other slides
								this.slides[i].style.opacity = 0.3;
								this.slides[i].style.pointerEvents = 'none';
							}
						}
					},
					activeIndexChange: function () {
						for (let i = 0; i < this.slides.length; i++) {
							// Set opacity to 1 for the activeIndex and the next two slides
							if (i >= this.activeIndex && i <= this.activeIndex + 3) {
								this.slides[i].style.opacity = 1;
								this.slides[i].style.pointerEvents = 'all';
							} else {
								// Set opacity to 0.3 for all other slides
								this.slides[i].style.opacity = 0.3;
								this.slides[i].style.pointerEvents = 'none';
							}
						}
					},
					resize: function () {
						for (let i = 0; i < this.slides.length; i++) {
							// Set opacity to 1 for the activeIndex and the next two slides
							if (i >= this.activeIndex && i <= this.activeIndex + 3) {
								this.slides[i].style.opacity = 1;
								this.slides[i].style.pointerEvents = 'all';
							} else {
								// Set opacity to 0.3 for all other slides
								this.slides[i].style.opacity = 0.3;
								this.slides[i].style.pointerEvents = 'none';
							}
						}
					},
					reachEnd: function () {
						this.slides[this.slides.length - 1].style.opacity = 1;
						this.slides[this.slides.length - 1].style.pointerEvents = 'all';
					},
					fromEdge: function () {
						this.slides[this.slides.length - 1].style.opacity = 0.3;
						this.slides[this.slides.length - 1].style.pointerEvents = 'none';
					},
					reachBeginning: function () {
						for (let i = 0; i < this.slides.length; i++) {
							// Set opacity to 1 for the activeIndex and the next two slides
							if (i >= this.activeIndex && i <= this.activeIndex + 3) {
								this.slides[i].style.opacity = 1;
								this.slides[i].style.pointerEvents = 'all';
							} else {
								// Set opacity to 0.3 for all other slides
								this.slides[i].style.opacity = 0.3;
								this.slides[i].style.pointerEvents = 'none';
							}
						}
					},
				},
			});
		},

		// hasBeenClickedHandler(value) {
		// 	this.hasBeenClicked = value;
		// },
	},

	components: {
		PostTile,
		// SecondaryButton,
		CarouselArrow,
		TertiaryButton,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.featured_posts_listing {
	grid-column: span 12;
	overflow-x: hidden;
	background: var(--background-colour);
	padding-top: var(--padding-top);
	padding-bottom: var(--padding-bottom);

	@media (max-width: $mobile-xl) {
		padding-top: var(--padding-top-mobile);
		padding-bottom: var(--padding-bottom-mobile);
	}

	.container {
		position: relative;
	}

	@media (max-width: $tablet) {
		padding: 48px 0 48px;
	}

	.slider-slider {
		grid-column: span 12;
		/* overflow: hidden; */
		padding-top: 55px;
		margin-top: -55px;
		position: relative;
		z-index: 5;

		@media (max-width: $tablet) {
			grid-column: span 12;
			overflow: visible;
		}

		@media (max-width: $mobile-xl) {
			grid-column: span 12;
			padding-top: 0;
			margin-top: unset;
		}

		@media (max-width: $mobile) {
			grid-column: span 4;
		}

		.swiper-slider {
			pointer-events: none;
		}

		.swiper-slide {
			height: unset;
			opacity: 1;
			transition: 0.2s ease all;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			/* @media (max-width: $mobile-xl) {
				&.swiper-slide-next {
					opacity: 0.5 !important;
					transition: 0.2s ease all;
				}
			} */
		}
	}

	.swiper-wrapper {
		z-index: 15;
	}

	header {
		grid-column: span 12;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		/* pointer-events: none; */
		// border-top: 1px solid var(--white);
		// padding-top: var(--gutter-tablet-desktop);

		@media (max-width: $tablet) {
			grid-column: span 12;
			justify-content: space-between;
		}

		@media (max-width: $mobile) {
			grid-column: span 4;
			flex-direction: row;
			align-items: center;
			gap: 10px;
		}

		a.site_button_secondary {
			pointer-events: all;
		}

		h2,
		h3 {
			/* font: normal normal 600 34px/40px var(--primary-font-family-display); */
			color: var(--cobalt);
			margin: 0;

			@media (max-width: $tablet) {
				color: var(--cobalt);
			}
		}

		h5 {
			margin: 0;
		}

		&.header-mobile {
			display: none;
			z-index: 10;

			@media (max-width: $mobile-xl) {
				border-top: 0 solid var(--cobalt);
				padding-top: 0;
				display: flex;
				justify-content: flex-end;
				align-items: center;
			}

			/* a {
				&.site_button_secondary {
					padding-left: 0;
					display: none;
					width: auto;

					@media (max-width: $mobile-xl) {
						display: flex;
						color: var(--white);
					}
				}
			} */
		}

		&.header-desktop {
			position: relative;
			z-index: 10;

			@media (max-width: $mobile-xl) {
				pointer-events: none;

				/* a {
					&.site_button_secondary {
						display: none;
					}
				} */
			}
		}

		/* .site_button_secondary {
			&::v-deep {
				span {
					color: var(--cobalt);
				}

				svg {
					path,
					line {
						stroke: transparent;
						fill: var(--light-blue);
					}
				}
			}
		} */
	}

	.container {
		column-gap: var(--gutter-tablet-desktop);
		row-gap: calc(var(--gutter-tablet-desktop) * 1);

		@media (max-width: $tablet) {
			grid-template-columns: repeat(12, 1fr);
			column-gap: var(--gutter-mobile);
			row-gap: var(--gutter-mobile);
		}

		@media (max-width: $mobile) {
			grid-template-columns: repeat(4, 1fr);
			column-gap: var(--gutter-mobile);
		}

		.post_tile {
			height: auto;
			transition: 0.2s ease opacity;
			/* opacity: 1 !important; */

			@media (max-width: 1920px) {
				grid-column: span 3;
			}

			@media (max-width: 1490px) {
				grid-column: span 3;
			}

			@media (max-width: $tablet) {
				grid-column: span 3;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 6;
			}

			@media (max-width: $mobile) {
				grid-column: span 4;
			}

			&::v-deep {
				.content {
					background: var(--white);
				}

				@media (max-width: $mobile-xl) {
					display: flex;
					flex-direction: column;

					.content {
						height: auto;
						background: var(--white);
					}
				}
			}
		}
	}
}

.swiper {
	width: 100%;
}

.swiper-next-prev {
	position: absolute;
	width: 100%;
	top: calc(50% + 30px);
	transform: translateY(-50%);
	z-index: 40;
	z-index: 20;

	@media (max-width: $mobile-xl) {
		/* max-width: calc(100% - 40px); */
		/* top: -42px; */
		/* transform: translateX(-50%); */
		top: calc(50% + 40px);
		bottom: unset;
		/* margin: 0 20px; */
	}

	.prev {
		opacity: 1;
		margin-left: 0;

		@media (max-width: $tablet) {
			top: 50%;
			margin-left: -9px;
		}
	}

	.next {
		opacity: 1;
		margin-right: 0;

		@media (max-width: $tablet) {
			top: 50%;
			margin-right: -9px;
		}
	}
}

.swiper-pagination {
	position: relative !important;
	grid-column: span 12;
	display: inline-flex;
	justify-content: center;
	gap: 10px;
	left: 0;
	width: 100%;
	position: absolute !important;
	top: 12px !important;
	bottom: unset !important;
	flex-wrap: wrap;
	z-index: 10;

	@media (max-width: $mobile-xl) {
		gap: 8px;
		display: none;
		/* top: -55px !important; */
	}

	& > .swiper-pagination-bullet-active {
		background: var(--cobalt) !important;
	}
}

/* .swiper-slide-prev {
	transition: 0.2s ease opacity;
	opacity: 0.2 !important;
} */
</style>
